$(function () {
    // Open chat widget on click
    $('.page-body a').on('click', function () {
        if ($(this).attr('href') === '#') {
            $('.chat-toggle').click();
        }
    });

    // Page Trunk Shows
    if ($('#page-trunk-shows').length > 0) {
        // Handles display and filters
        var events_container = $('#secondaryEvents');
        var event_box = "";
        // Get Events from API endpoint
        $.getJSON("https://api.amsale.com/api/events.json", function (data) {

            var parsed_start_date, parsed_end_date, start_date_month, end_date_month;
            var split_start_date, split_end_date;
            var date_string = "";

            $.each(data.data.events, function (key, val) {
                split_start_date = val.start_date.split('-');
                start_date_month = split_start_date[1];
                parsed_start_date = parseInt(split_start_date[2]);

                split_end_date = val.end_date.split('-');
                end_date_month = split_end_date[1];
                parsed_end_date = parseInt(split_end_date[2]);

                date_string = `${start_date_month}/${parsed_start_date} - ${end_date_month}/${parsed_end_date}`;

                //Build event boxes
                event_box += '<div class="eventBox" data-category="' + val.category.toLowerCase().replace(/ /g, '-') + '">';
                event_box += '<h3>' + val.presented_by + '</h3>';
                event_box += '<h4 style="color: #01372c;">' + val.name + '</h4>';
                event_box += '<p class="event_date">' + date_string + '</p>';
                event_box += '<p class="event_location">' + val.location + '</p>';
                event_box += `<a href="${val.link}" target="_blank" rel="noopener noreferrer" aria-label="book an appointment for ${val.name}"> Book an Appointment <span class="sr-only">(opens in a new window)</span></a>`;
                event_box += '</div>';
            });
          
            // Append events to container
            $(events_container).append(event_box);
        });

        // Filter Events Boxes    
        $('select#collection-filter').on('change', function (e) {
            e.preventDefault();
            var $filterName = $(this).val();
            var $boxes = $('.eventsList #secondaryEvents .eventBox');
            $('.no-results-events').css('opacity', 0);

            if ($filterName == '') {
                $boxes.removeClass('is-animated')
                    .fadeOut().promise().done(function () {
                        $boxes.addClass('is-animated').fadeIn();
                    });
            } else {
                $boxes.removeClass('is-animated')
                    .fadeOut().promise().done(function () {
                        $boxes.filter('[data-category = "' + $filterName + '"]')
                            .addClass('is-animated').fadeIn();
                    });
            }

            // Show empty results message if no box is displayed
            setTimeout(function () {
                if (!$boxes.is(":visible")) {
                    $('.no-results-events').css('opacity', 1);
                }
            }, 500);
        });
    }
});